import { isPlpListingQueryKey } from './appliedFilters'

export const ODOSCOPE_ROUTE_SLICE_STATE_KEY = 'useOdoscope-slice-by-route'
export const ODOSCOPE_ROUTE_SLICE_PAYLOAD_KEY = `$s${ODOSCOPE_ROUTE_SLICE_STATE_KEY}`

export const createOdoscopeRouteStateKey = (fullPath: string) => {
  const [pathAndQuery] = fullPath.split('#', 1)
  const [path, queryString] = pathAndQuery!.split('?', 2)
  const query = new URLSearchParams(queryString)

  Array.from(query.keys()).forEach((key) => {
    if (!isPlpListingQueryKey(key)) {
      query.delete(key)
    }
  })

  const listingQuery = query.toString()
  return encodeURIComponent(`${path}${listingQuery ? `?${listingQuery}` : ''}`)
}
